﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const components_1 = require("../../components");
const app_commons_1 = require("@its-suite/app-commons");
class ErrorPageInternalErrorInternal extends React.Component {
    constructor(props) {
        super(props);
        this.getErrorPage = () => {
            let buttonText = 'Go to homepage';
            let titleText = 'Application error';
            let subtitleText = '';
            let errorHintText = 'If you continue to experience problems please contact your ITS Suite administrator for assistance';
            if (this.props.translationsAvailable) {
                buttonText = this.props.translate('GoToHomePage');
                titleText = `${this.props.translate('ApplicationError')}`;
                errorHintText = this.props.translate('ErrorPage_Hint');
            }
            return (React.createElement("div", null,
                React.createElement(app_commons_1.ErrorPage, { buttonText: buttonText, titleText: titleText, subtitleText: subtitleText, errorHintText: errorHintText, redirectTo: app_commons_1.ApplicationRoutes.ROOT, reloadPageOnRedirect: true })));
        };
    }
    render() {
        if (this.props.translationsAvailable) {
            let properties = {
                appName: process.env.APP_NAME,
                appVersion: process.env.APP_VERSION,
                menuOptions: null,
                appContent: this.getErrorPage()
            };
            return (React.createElement("div", null,
                React.createElement(components_1.AppBar, Object.assign({}, properties))));
        }
        else {
            return (this.getErrorPage());
        }
    }
}
function mapStateToProps(state) {
    return {
        translate: state.translate,
        translationsAvailable: state.locale && Object.keys(state.locale.translations).length > 0
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(ErrorPageInternalErrorInternal);
//# sourceMappingURL=ErrorPageInternalError.js.map